module.exports = __webpack_public_path__ + "res/materialdesignicons-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/lumx/fonts/materialdesignicons-webfont.eot?v=1.9.32
// module id = 110
// module chunks = 1